import callApi from './personnelService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}`;

export const getSaId = (paginationInfo) => callApi({
    method: 'POST',
    endpoint: `${basePath}/get-sa-info`,
    body: paginationInfo
  });
